import {
  BulkLoadedType,
  ErrorType,
  InvalidateType,
  LoadedMoreType,
  LoadedType,
  type QueryParams,
  RemoveType,
  RequestMoreType,
  RequestType,
} from 'common/actions/ideaQueries';

import queryReducerFactory, { type QueriesState, type QueryState } from './queryReducerFactory';
export { defaultState } from './queryReducerFactory';

import type { LoadedAction, QueryAction } from 'common/actions/queryActionFactory';
import type { Idea } from 'common/api/endpoints/idea';

type IdeaIDOnly = Pick<Idea, '_id'>;
export type IdeaIDQueriesState = QueriesState<IdeaIDOnly, QueryParams>;
export type IdeaIDQueryState = QueryState<IdeaIDOnly, QueryParams> | undefined;
export type IdeaQueryState = QueryState<Idea, QueryParams> | undefined;

const queryReducer = queryReducerFactory<IdeaIDOnly, QueryParams>({
  bulkLoadedType: BulkLoadedType,
  errorType: ErrorType,
  invalidateType: InvalidateType,
  loadedMoreType: LoadedMoreType,
  loadedType: LoadedType,
  requestMoreType: RequestMoreType,
  requestType: RequestType,
  removeType: RemoveType,
});

export default function reducer(
  state: IdeaIDQueriesState,
  action: QueryAction<IdeaIDOnly, QueryParams>
) {
  let actionToUse = action;
  if (action.type === LoadedMoreType || action.type === LoadedType) {
    const loadedAction = action as LoadedAction<IdeaIDOnly, QueryParams>;
    actionToUse = {
      ...loadedAction,
      items: loadedAction.items.map((item) => {
        return {
          _id: item._id,
        };
      }),
    };
  }

  return queryReducer(state, actionToUse);
}
